import * as React from 'react';

const Content = ({ screen, screensMapping }: { screen: string, screensMapping: object }) => {
  if (screen) {
    return screensMapping[screen];
  } else {
    return <div>content</div>
  };
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content/index.tsx